var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoBadgeCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 2.5C7.84224 2.5 4.48438 5.85786 4.48438 10C4.48438 12.0711 5.32384 13.9461 6.68107 15.3033C6.69875 15.321 6.71652 15.3386 6.73438 15.3561C8.08719 16.6823 9.94028 17.5 11.9844 17.5C14.0285 17.5 15.8816 16.6823 17.2344 15.3561C18.6229 13.9949 19.4844 12.098 19.4844 10C19.4844 5.85786 16.1265 2.5 11.9844 2.5ZM15.4914 8.52447L11.4795 12.5363C11.1866 12.8292 10.7118 12.8292 10.4189 12.5363L8.47724 10.5947C8.18435 10.3018 8.18434 9.82695 8.47724 9.53405C8.77013 9.24116 9.245 9.24116 9.5379 9.53405L10.9492 10.9453L14.4307 7.46381C14.7236 7.17092 15.1985 7.17092 15.4914 7.46381C15.7843 7.7567 15.7843 8.23158 15.4914 8.52447Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.9844 19.0001C13.9436 19.0001 15.7567 18.374 17.2344 17.311V21.7501C17.2344 22.01 17.0998 22.2514 16.8787 22.3881C16.6576 22.5247 16.3815 22.5372 16.149 22.4209L12.3198 20.5063C12.1086 20.4008 11.8601 20.4008 11.649 20.5063L7.81979 22.4209C7.58729 22.5372 7.31119 22.5247 7.09008 22.3881C6.86896 22.2514 6.73438 22.01 6.73438 21.7501V17.311C8.21205 18.374 10.0251 19.0001 11.9844 19.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoBadgeCheck);
export default __webpack_public_path__ + "static/media/DuoBadgeCheck.8f548c52aa4f2c912f3565d9a1bae634.svg";
export { ForwardRef as ReactComponent };